export const DELETE_SUCCESS = 'Группа пользователей удалена';
export const DELETE_ERROR = 'Не удалось удалить группу пользователей';
